/**
 * The external dependencies.
 */
import React from 'react';
/**
 * The internal dependencies.
 */
import CloseButton from '../../components/task/close-button';
import Header from '../../components/task/shop/header';
import Text from '../../components/task/shop/text';

const Bar = ({longNumber, onClose, color = '#43abf3'}) => (
    <Header color={color} textColor="#fff">
        <Text large>
            Produkt:
        </Text>

        <Text large>
            {longNumber}
        </Text>


        <Text flex small>
            Schließen

            <CloseButton onClick={onClose}/>
        </Text>
    </Header>
);

export default Bar;



// WEBPACK FOOTER //
// ./src/containers/disponent/bar.js